import { useState } from "react";

import { Badge, Button, type ButtonProps } from "@icg360/design-system";

import { useNotificationContext } from "components/notifications/context";
import { NotificationsDrawer } from "components/notifications/notifications-drawer/notification-drawer";
import { trackEvent } from "utils";

import styles from "./notifications-header-button.module.scss";

type NotificationsHeaderButtonProps = {
  buttonClassName?: string;
  appearance?: ButtonProps["appearance"];
  testId: string;
};

export const NotificationsHeaderButton = ({
  buttonClassName,
  appearance,
  testId,
}: NotificationsHeaderButtonProps) => {
  const [isOpen, setIsOpen] = useState(false);
  const { total } = useNotificationContext();

  const openNotificationsDrawer = () => {
    trackEvent("Notification menu opened");
    setIsOpen(!isOpen);
  };

  return (
    <>
      <div className={styles.bellButtonWrapper}>
        <Button
          icon="Bell"
          appearance={appearance}
          onPress={openNotificationsDrawer}
          data-testid={testId}
          aria-label="View notifications"
          className={buttonClassName}
        />
        {total > 0 && (
          <div className={styles.notificationCount}>
            <Badge.Numeric number={total} appearance="success" size="small" />
          </div>
        )}
      </div>
      <NotificationsDrawer isOpen={isOpen} onClose={() => setIsOpen(false)} />
    </>
  );
};
